import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/SF-Pro.ttf";
import "./assets/fonts/GillSans.ttc";
import "./assets/fonts/Arial Rounded Bold.ttf";
import { MaintenanceModeProvider } from "./components/MaintenanceMode/MaintenanceModeProvider";
//disable logs for production
if (process.env.NODE_ENV === `production`) {
  console.log = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <MaintenanceModeProvider>
      <App />
    </MaintenanceModeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
serviceWorker.unregister();
